import React, { useRef } from "react";
import "./Banner.css";
import women from "../../../../assets/images/Banner/young-woman-working-laptop-isolated-white-background.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
function Banner({ executeScroll}) {
  const { t } = useTranslation();
  return (
    <div className="banner">
      <div className="banner-container-1">
        <div className="banner-text">
          <h1 className="banner-para1">{t("BE AT THE BEST SOFTWARE TRAINING CENTRE")}</h1>
          <h2 className="banner-head1"> <span className="msq-blue">{t("Benefit from")}</span> </h2>
          <p
            className="learn-text-para"
            style={{ fontFamily: "'Source Sans 3', sans-serif" }}
          >
            {t("Master in-demand skills, land your dream job,")}
            {t("and make a difference in the world")}
          </p>
          <br />
          <Link
            className="btn btn-primary"
            style={{ zIndex: 50 }}
            onClick={executeScroll ? executeScroll : null}
          >
            <b>{t("Explore")}</b>
          </Link>
        </div>
      </div>
      <div className="banner-container-2">
        <img src={women} className="women" alt="women" style={{ zIndex: 40 }}/>
      </div>
    </div>
  );
}

export default Banner;
